import { CIRCLE, CIRCLE_X, LOADER2 } from "icons";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";

import { Button } from "ui";
import { CircleXIcon } from "lucide-react";
import Icon from "components/icon";
import classNames from "classnames";
import { cn } from "utils";

export default function CommonSelect({
  placeholder,
  value, // This should be the item.id
  selectedItem, // This should be the complete item object
  onValueChange, // This will receive the complete item object
  items,
  disabled = false,
  groupLabel,
  required = false,
  className = "max-w-80",
  showClearButton = true,
}) {
  const handleValueChange = (selectedValue) => {
    // Find the complete item object by the selected value
    const selectedItemObject = items?.find((item) => item.id === selectedValue);

    // Pass the complete item object to the callback
    onValueChange(selectedItemObject);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onValueChange(null);
  };

  // Get display value - use selectedItem if available, otherwise find by value
  const getDisplayValue = () => {
    if (selectedItem) {
      return selectedItem.name;
    }
    if (value) {
      const item = items?.find((item) => item.id === value);
      return item?.name;
    }
    return "";
  };

  const currentValue = selectedItem?.id || value;

  return (
    <Select
      disabled={disabled}
      onValueChange={handleValueChange}
      value={currentValue}
      required={required}
    >
      <div className="relative">
        <SelectTrigger
          className={cn("w-full", className)}
          value={currentValue}
          showClearButton={showClearButton}
        >
          {/* <SelectValue placeholder={placeholder} className="ml-2"> */}
          <span className={cn(!value && "text-muted-foreground")}>
            {" "}
            {getDisplayValue() || placeholder}
          </span>
          {/* </SelectValue> */}
        </SelectTrigger>
        {currentValue && showClearButton && (
          <Button
            variant="ghost"
            className="absolute right-0 inset-y-0 hover:bg-transparent"
            onClick={handleClear}
          >
            <Icon icon={CIRCLE_X} className="h-4 w-4 opacity-50" />
          </Button>
        )}
      </div>
      <SelectContent className="w-full">
        <SelectGroup>
          {groupLabel && <SelectLabel>{groupLabel}</SelectLabel>}
          {items?.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export function EvtSelect({
  value,
  onChange,
  className = "",
  data,
  isLoading = false,
  placeholder = "Select",
  type = "form",
  showClearButton = true,
  ...props
}) {
  const handleClear = (e) => {
    e.stopPropagation();
    onChange(type === "filter" ? undefined : "");
  };

  return (
    <Select onValueChange={onChange} value={value} {...props}>
      <SelectTrigger
        className={classNames(
          className,
          "w-full max-w-full flex items-center  justify-between overflow-hidden"
        )}
        value={value || isLoading}
        showClearButton={showClearButton}
      >
        <SelectValue placeholder={placeholder} />

        <div className="flex items-center">
          {isLoading ? (
            <Icon
              icon={LOADER2}
              className="h-4 w-4 animate-spin text-muted-foreground ml-2"
            />
          ) : (
            value &&
            showClearButton && (
              <span
                type="button"
                onPointerDown={(e) => e.preventDefault()} // prevents select opening
                onClick={handleClear}
                className=" hover:text-muted-foreground focus:outline-none"
                tabIndex={-1} // prevents stealing focus from select
              >
                <Icon icon={CIRCLE_X} className="h-4 w-4 opacity-50" />
              </span>
            )
          )}
        </div>
      </SelectTrigger>

      {!isLoading && (
        <SelectContent className="max-w-full">
          {data?.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item.name}
            </SelectItem>
          ))}
        </SelectContent>
      )}
    </Select>
  );
}
